import { useEffect, useState } from "react";

import { cn } from "lib/utlis";
import AppPlateFormLogos from "components/appplateformlogos";

const headerMenu = [
  { id: 0, label: "Home", url: "/" },
  { id: 0, label: "How it work", url: "/howitworks" },
  { id: 0, label: "About Us", url: "/aboutus" },
  { id: 0, label: "Contact Us", url: "/contactus" },
  { id: 0, label: "For Partner", url: "/partner" },
];

export default function Header({ showAppPlatformLogo = true }) {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Only update sticky state if menu is closed
      if (!isMenuOpen) {
        setIsSticky(window.scrollY > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMenuOpen]); // Add isMenuOpen to dependency array

  // Update isSticky when menu opens/closes
  useEffect(() => {
    if (isMenuOpen) {
      setIsSticky(false);
    } else {
      setIsSticky(window.scrollY > 0);
    }
  }, [isMenuOpen]);

  return (
    <header
      className={cn(
        "fixed flex-1 w-full top-0 z-30 transition-all duration-300",
        isSticky ? "sticky-top" : ""
      )}
    >
      <nav className="container flex-1 flex items-center justify-between py-3.5">
        <div className="flex">
          <a href="/" className="-m-1.5 p-1.5">
            <img alt="Surpeats" src="images/surpeats-logo.svg" />
          </a>
        </div>

        <div
          className={cn(
            "items-center gap-14 lg:flex",
            isMenuOpen
              ? "flex flex-col fixed inset-0 pt-20 gap-8 bg-primary-200"
              : "hidden"
          )}
        >
          {headerMenu.map((menu, index) => {
            return (
              <a
                key={`header-${index}`}
                href={menu?.url}
                className="mobile-menu-item text-white text-sm font-medium transition-colors hover:text-blue-100"
              >
                {menu?.label}
              </a>
            );
          })}
        </div>

        <AppPlateFormLogos
          showAppPlatformLogo={showAppPlatformLogo}
          className="!hidden lg:!flex"
        />

        <button
          className="menu-toggle block lg:hidden z-50"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6C22 6.26522 21.8946 6.51957 21.7071 6.70711C21.5196 6.89464 21.2652 7 21 7H3C2.73478 7 2.48043 6.89464 2.29289 6.70711C2.10536 6.51957 2 6.26522 2 6ZM2 12.032C2 11.7668 2.10536 11.5124 2.29289 11.3249C2.48043 11.1374 2.73478 11.032 3 11.032H21C21.2652 11.032 21.5196 11.1374 21.7071 11.3249C21.8946 11.5124 22 11.7668 22 12.032C22 12.2972 21.8946 12.5516 21.7071 12.7391C21.5196 12.9266 21.2652 13.032 21 13.032H3C2.73478 13.032 2.48043 12.9266 2.29289 12.7391C2.10536 12.5516 2 12.2972 2 12.032ZM3 17.065C2.73478 17.065 2.48043 17.1704 2.29289 17.3579C2.10536 17.5454 2 17.7998 2 18.065C2 18.3302 2.10536 18.5846 2.29289 18.7721C2.48043 18.9596 2.73478 19.065 3 19.065H21C21.2652 19.065 21.5196 18.9596 21.7071 18.7721C21.8946 18.5846 22 18.3302 22 18.065C22 17.7998 21.8946 17.5454 21.7071 17.3579C21.5196 17.1704 21.2652 17.065 21 17.065H3Z"
                fill="white"
              />
            </svg>
          )}
        </button>
      </nav>
    </header>
  );
}
